<div
  class="sb-rich-text"
  [class.sb-rich-text--readonly]="!editable"
  [class.sb-rich-text--maximized]="maximized"
  [class.sb-rich-text--plain]="plainText()"
  [class.sb-rich-text--raw]="rawMode()"
  [class.sb-rich-text--placeholder]="placeholderShown()">
  @if (!rawMode() && tools().length) {
  <!-- mousedown is cancelled so the editor keeps its selection while a tool is used. -->
  <div class="sb-rich-text__toolbar" role="toolbar" (mousedown)="$event.target.tagName !== 'INPUT' && $event.preventDefault()">
    @for (tool of tools(); track $index) {
      @switch (tool) {
        @case ('|') {
        <span class="sb-rich-text__separator" aria-hidden="true"></span>
        }
        @case ('format') {
        <button type="button" class="sb-rich-text__menu-button" title="Paragraph Format" aria-label="Paragraph Format"
          [disabled]="isDisabled(tool)" (click)="run(tool)">{{ currentFormat }} <i class="fa fa-caret-down" aria-hidden="true"></i></button>
        }
        @case ('font') {
        <button type="button" class="sb-rich-text__menu-button" title="Font Name" aria-label="Font Name"
          [disabled]="isDisabled(tool)" (click)="run(tool)">{{ currentFont || 'Font' }} <i class="fa fa-caret-down" aria-hidden="true"></i></button>
        }
        @case ('fontBrowser') {
        <button type="button" class="sb-rich-text__menu-button" title="Font" aria-label="Font"
          [disabled]="isDisabled(tool)" (click)="run(tool)">{{ currentFont || fontBrowserLabel || 'Font' }}</button>
        }
        @case ('fontSize') {
        <button type="button" class="sb-rich-text__menu-button" title="Font Size" aria-label="Font Size"
          [disabled]="isDisabled(tool)" (click)="run(tool)">{{ currentFontSize || 'Size' }} <i class="fa fa-caret-down" aria-hidden="true"></i></button>
        }
        @default {
        <button
          type="button"
          class="sb-rich-text__button"
          [class.sb-rich-text__button--on]="isOn(tool)"
          [attr.aria-pressed]="isOn(tool)"
          [attr.title]="toolTitle[tool]"
          [attr.aria-label]="toolTitle[tool]"
          [disabled]="isDisabled(tool)"
          (click)="run(tool)">
          <i [class]="toolIcon[tool]" aria-hidden="true"></i>
        </button>
        }
      }
    }
  </div>
  }

  @if (panel) {
  <div class="sb-rich-text__panel" [class.sb-rich-text__panel--form]="panel === 'link' || panel === 'image'" role="dialog"
    [attr.aria-label]="panelTitle[panel]">
    @switch (panel) {
      @case ('format') {
        @for (format of formats; track format.level) {
        <button type="button" class="sb-rich-text__option" (click)="setFormat(format.level)">{{ format.label }}</button>
        }
      }
      @case ('font') {
        @for (font of fontNames; track font.label) {
        <button type="button" class="sb-rich-text__option" [style.font-family]="font.family"
          (click)="setStyle('font-family', font.family)">{{ font.label }}</button>
        }
      }
      @case ('fontSize') {
        @for (size of fontSizes; track size) {
        <button type="button" class="sb-rich-text__option" (click)="setStyle('font-size', size)">{{ size.replace('px', '') }}</button>
        }
      }
      @case ('textColor') {
        <button type="button" class="sb-rich-text__option" (click)="setStyle('color', null)">Automatic</button>
        <div class="sb-rich-text__colors">
          @for (color of colors; track color.value) {
          <button type="button" class="sb-rich-text__color" [style.background]="color.value" [attr.title]="color.name"
            [attr.aria-label]="color.name" (click)="setStyle('color', color.value)"></button>
          }
        </div>
        <label class="sb-rich-text__more-colors">More Colors… <input type="color" #textColor (change)="setStyle('color', textColor.value)"></label>
      }
      @case ('bgColor') {
        <button type="button" class="sb-rich-text__option" (click)="setStyle('background-color', null)">Automatic</button>
        <div class="sb-rich-text__colors">
          @for (color of colors; track color.value) {
          <button type="button" class="sb-rich-text__color" [style.background]="color.value" [attr.title]="color.name"
            [attr.aria-label]="color.name" (click)="setStyle('background-color', color.value)"></button>
          }
        </div>
        <label class="sb-rich-text__more-colors">More Colors… <input type="color" #bgColor (change)="setStyle('background-color', bgColor.value)"></label>
      }
      @case ('link') {
        <form (submit)="$event.preventDefault(); applyLink()">
          <label class="sb-rich-text__label">URL
            <input class="form-control form-control-sm" type="text" name="url" [(ngModel)]="linkUrl" autofocus>
          </label>
          @if (!editor?.hasSelection() && !editor?.link()) {
          <label class="sb-rich-text__label">Display Text
            <input class="form-control form-control-sm" type="text" name="text" [(ngModel)]="linkText">
          </label>
          }
          <label class="sb-rich-text__check"><input type="checkbox" name="newTab" [(ngModel)]="linkNewTab"> Open in a new tab</label>
          <div class="sb-rich-text__actions">
            @if (editor?.link()) {
            <button type="button" class="btn btn-sm btn-link text-danger" (click)="removeLink()">Remove Link</button>
            }
            <button type="button" class="btn btn-sm btn-default" (click)="closePanel()">Cancel</button>
            <button type="submit" class="btn btn-sm btn-primary">OK</button>
          </div>
        </form>
      }
      @case ('image') {
        <form (submit)="$event.preventDefault(); applyImage()">
          <label class="sb-rich-text__label">URL
            <span class="sb-rich-text__inline">
              <input class="form-control form-control-sm" type="text" name="url" [(ngModel)]="imageUrl" autofocus>
              @if (imageBrowse()) {
              <button type="button" class="btn btn-sm btn-default" (click)="imageBrowseRequest.emit()">Browse Server</button>
              }
            </span>
          </label>
          <div class="sb-rich-text__actions">
            <button type="button" class="btn btn-sm btn-default" (click)="closePanel()">Cancel</button>
            <button type="submit" class="btn btn-sm btn-primary">OK</button>
          </div>
        </form>
      }
    }
  </div>
  }

  <div
    #content
    class="sb-rich-text__content"
    [hidden]="rawMode()"
    [class.sb-rich-text__content--resizable]="resizable()"
    [style.height.px]="autoGrow() || maximized ? null : height()"
    [style.min-height.px]="autoGrow() ? height() : null"></div>

  @if (placeholderShown()) {
  <div class="sb-rich-text__placeholder" aria-hidden="true" [innerHTML]="placeholder()"></div>
  }

  @if (rawMode()) {
  <div class="sb-rich-text__raw-note">
    This text has HTML the editor would change, so it is shown as HTML.
    @if (editable) {
    <button type="button" class="btn btn-link btn-sm p-0" (click)="editWithFormatting()">Edit with formatting instead</button>
    }
  </div>
  <textarea
    class="form-control sb-rich-text__source"
    [style.min-height.px]="height()"
    [value]="html()"
    [readOnly]="!editable"
    [attr.aria-label]="ariaLabel() || 'HTML'"
    (input)="onSourceInput($any($event.target).value)"
    (blur)="blurred.emit()"></textarea>
  }
</div>
